import { onAddNotification } from "../../utils/PushNotification";

export const createPushNotification = ({ dispatch, nodes, nodeId }) => {
  const currNode = nodes.find((node) => node.id === nodeId);

  const axis = {
    x: currNode.position.x + 180,
    y: currNode.position.y - 1,
  };

  onAddNotification(dispatch, axis, nodeId);
};
